import { StatRow } from './stat-row';
import { StatsPeriodFootnote } from './stats-period-footnote';
import { useGetOrgActivityStats } from '../../../api/queries/analyticsQueries/useGetOrgActivityStats';

/** High-level activity stats for a single matter, rendered inside a popover. */
export function MatterStatsPopover({
  matterId,
  matterName,
  organisationId,
  startDate,
  endDate,
}: {
  matterId: string;
  matterName: string;
  organisationId: string;
  startDate?: Date;
  endDate?: Date;
}) {
  const { data: stats } = useGetOrgActivityStats({
    data: { organisationId, matterId, startDate, endDate },
  });

  return (
    <div>
      <div className="mb-2 border-b border-gray-100 pb-2">
        <p className="truncate text-sm font-medium text-gray-900">{matterName}</p>
      </div>

      <StatRow label="Pages" value={stats?.pages} />
      <StatRow label="Runs" value={stats?.runs} />
      <StatRow label="Fact chronologies" value={stats?.chronologies} />
      <StatRow label="Doc chronologies" value={stats?.docChronologies} />
      <StatRow label="Kim threads" value={stats?.kimThreads} />

      <StatsPeriodFootnote startDate={startDate} endDate={endDate} />
    </div>
  );
}
